import { FC } from 'react';
import { Wysiwyg } from '../../../../../components/input';
import { unCamelCase } from '../../../../../helpers';
import { ITemplateInputProps } from '../../../../../models';

// NOTE: Should this need to be extended to include a Raw / HTML toggle button on the toolbar,
// use the following example: https://codepen.io/alexkrolick/pen/XgaVVX
export const EditorInput: FC<ITemplateInputProps> = ({ input, value, onChange, isRequired }) => {
  const { sectionName } = input;

  const handleChange = (e: string) => {
    onChange(e, input);
  };

  return (
    <Wysiwyg
      id={sectionName}
      onChange={handleChange}
      value={value}
      label={unCamelCase(sectionName)}
      isRequired={isRequired}
    />
  );
};
